module.exports = __webpack_public_path__ + "static/assets/7efbbe0728dcb6d7a5732dd439ff03cc.svg";